import { isNotNullOrUndefined } from 'utils/utils';

/**
 * Get a flat string array from all the values of an object's nested property
 * @param objectArray The object to search in
 * @param subPropertyName The object's property to search in
 * @param propertyInSubPropertyName The property within the subproperty to search for
 */
export const getUniquePropertiesFromSubArray = (
  objectArray: any[],
  subPropertyName: string,
  propertyInSubPropertyName: string,
) => {
  return isNotNullOrUndefined(objectArray)
    ? Array.from(
        new Set(
          Array.from(
            objectArray.map((x: any) => x[subPropertyName].map((element: any) => element[propertyInSubPropertyName])),
          ).flat(),
        ),
      )
    : [];
};

export const getUniquePropertyFromArray = (object: any, subProperty: string, fieldName: string) => {
  return Array.from(new Set(object[subProperty].map((element: any) => element[fieldName])));
};

/**
 * Check if a string is present as a value anywhere in an object
 * @param obj The object to check
 * @param query The string value to search for
 */
export const valueExistsInObject = (obj: any, query: string) => {
  if (!query || !obj) {
    return true;
  }
  return JSON.stringify(obj).toLowerCase().indexOf(query.toLowerCase()) > 0;
};
